import { useState, useEffect } from "react";
import axios from "axios";
import socket from "../components/chat/Soclet";
import UserList from "../components/chat/ChatList";
import ChatWindow from "../components/chat/ChatWindow";
import { useAuth } from "../Auths/CheckUser";

const ChatSystem = () => {
  const { user } = useAuth();
  const [messages, setMessages] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  //  Handle responsive layout
  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchMessages = async () => {
      if (!selectedUser || !user?.id) return;
      try {
        const res = await axios.get(
          `https://bpohasil.ngrok.app/api/chat/${user.id}/${selectedUser.id}`
        );
        setMessages(res.data);
      } catch (err) {
        console.error("Error loading messages:", err);
      }
    };
    fetchMessages();

    if (selectedUser && user?.id) {
      socket.emit("joinRoom", { senderId: user.id, receiverId: selectedUser.id });
    }
  }, [selectedUser, user?.id]);

  useEffect(() => {
    const handleReceiveMessage = (newMessage) => {
      setMessages((prev) => {
        if (
          selectedUser &&
          ((newMessage.senderId === user.id && newMessage.receiverId === selectedUser.id) ||
            (newMessage.senderId === selectedUser.id && newMessage.receiverId === user.id))
        ) {
          return [...prev, newMessage];
        }
        return prev;
      });
    };

    socket.on("receiveMessage", handleReceiveMessage);
    return () => socket.off("receiveMessage", handleReceiveMessage);
  }, [selectedUser, user?.id]);

  const handleSend = async ({ text, file }) => {
    if (!selectedUser) return alert("Select a user first!");
    if (!text && !file) return;

    const formData = new FormData();
    formData.append("senderId", user.id);
    formData.append("receiverId", selectedUser.id);
    if (text) formData.append("message", text);
    if (file) formData.append("file", file);

    try {
      const res = await axios.post("https://bpohasil.ngrok.app/api/chat", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const sentMessage = res.data;

      const cleanMessage = {
        id: sentMessage.id,
        senderId: user.id,
        receiverId: selectedUser.id,
        message: sentMessage.message || null,
        fileUrl: sentMessage.fileUrl || null,
        fileName: sentMessage.fileName || null,
        createdAt: sentMessage.createdAt,
      };

      socket.emit("sendMessage", cleanMessage);
    } catch (err) {
      console.error("Error sending message:", err);
    }
  };

  return (
    <div className="flex bg-gray-100 h-[84vh]">
      {/* Desktop layout */}
      {!isMobileView && (
        <>
          <UserList
            user={user}
            selectedUser={selectedUser}
            onSelectUser={setSelectedUser}
          />
          {selectedUser ? (
            <ChatWindow
              messages={messages}
              onSend={handleSend}
              currentUserId={user.id}
              selectedUser={selectedUser}
              setSelectedUser={setSelectedUser}
              isMobileView={false}
            />
          ) : (
            <div className="flex-1 flex items-center justify-center text-gray-500">
              Select a user to start chatting
            </div>
          )}
        </>
      )}

      {/* Mobile layout */}
      {isMobileView && (
        <>
          {!selectedUser ? (
            <UserList
              user={user}
              selectedUser={selectedUser}
              onSelectUser={setSelectedUser}
            />
          ) : (
            <ChatWindow
              messages={messages}
              onSend={handleSend}
              currentUserId={user.id}
              selectedUser={selectedUser}
              setSelectedUser={setSelectedUser}
              isMobileView={true}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ChatSystem;
